import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import buildUrl from '../../objects/CommonUse/build_URL';
import Config from '../../config';

const mapStateToProps = (state) => ({
    gameSettings: state.gameSettings,
    gameData: state.gameData
    
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};


class ChangeGameSettingsModal extends Component {
            constructor(props) {
              super(props);
              this.handleClick = this.handleFlipCardChange.bind(this);
              this.handleClick = this.handleTrainAnimationChange.bind(this);
              this.handleClick = this.handleGameSpinnerChange.bind(this);
              this.gameInfo = this.props.gameInfo;
              this.state={
                timeOut: 0,
                flipCard: true,
                trainAnimation: true,
                gameSpinner: true,
                headers: setHeadersForFetch(),
                environment: Config.dataURL.currentEnv,
            };
    }

    componentDidMount(){
        const gameSettings = this.props.gameSettings;
        this.setState({flipCard: gameSettings.flipCard});
        this.setState({trainAnimation: gameSettings.trainAnimation});
        this.setState({gameSpinner: gameSettings.gameSpinner});
    }

    handleFlipCardChange(checked){
        this.setState({flipCard: checked});
    }

    handleTrainAnimationChange(checked){
        this.setState({trainAnimation: checked});
    }

    handleGameSpinnerChange(checked){
        this.setState({gameSpinner: checked});
    }

    
    render() {
    return <>
        <Modal show={this.props.modalOpen}  size="sm" 
            scrollable="true" animation={false}>
            <Modal.Header className="backgroundTopBottom"  >
                <Modal.Title>
                    <div>Change Game Settings</div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                {this.props.gamePhase === "1" ?
                    <div>
                        <div className= "">
                            <input type="checkbox" id="flipCard" name="flipCard" checked={this.state.flipCard}
                            onChange={(val) => this.handleFlipCardChange(val.target.checked)}/>
                            <label htmlFor="flipCard">&nbsp;&nbsp; Flip Card Animation</label> 
                        </div>
                        <div className="ml-4 mt-2">
                            Game Spinner Animation (not yet active)
                        </div>
                    </div>
                :
                    <div>
                        <div className= "mt-2">
                            <input type="checkbox" id="gameSpinner" name="gameSpinner" 
                            checked={this.state.gameSpinner}
                            onChange={(val) => this.handleGameSpinnerChange(val.target.checked)}/>
                            <label htmlFor="gameSpinner">&nbsp;&nbsp; Game Spinner Animation</label> 
                        </div>
                    </div>
                }
                <div className= "">
                    <input type="checkbox" id="trainAnimation" name="trainAnimation" 
                    checked={this.state.trainAnimation}
                    onChange={(val) => this.handleTrainAnimationChange(val.target.checked)}/>
                    <label htmlFor="trainAnimation">&nbsp;&nbsp; End of Turn Train Animation</label> 
                </div>

        </Modal.Body>
        <Modal.Footer className="p-0 backgroundTopBottom">
           
            <Button variant="primary"  onClick={() => this.saveNewGameSettings("submit")}>
                    Save Changes
            </Button>
             
            <Button variant="secondary"  onClick={() => this.saveNewGameSettings("close")}>
                    Close
            </Button>
        </Modal.Footer>
        </Modal>
        </>
    }
    
    saveNewGameSettings(action){
        if (action === "submit"){
            const gameSettings = {flipCard: this.state.flipCard, 
                gameSpinner: this.state.gameSpinner,
                trainAnimation: this.state.trainAnimation};
            this.props.setInfoRedux(gameSettings, "gameSettings");
            this.updateGameSettings(gameSettings);
        }else{
            this.props.onClose();
        }
    }
    
    updateGameSettings(gameSettings){
        const funcName = "updateGameSettings";
        const urlParm = "?gameID=" + this.props.gameData._id;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify({gameSettings: gameSettings})
            })
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (output.statusCode === 200){ 
                    this.props.setGameInfo(output.body, "gameData");
                    if(this.state.timeout) clearTimeout(this.state.timeout);
                        this.state.timeout = setTimeout(() => {
                        this.props.onClose();
                    }, 500);                    
                }else{
                    const dataObject = {gameID: this.props.gameData._id, gameSettings: gameSettings};
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: dataObject};
                    this.props.processError(errorObj);
                }
            });
            }
        });
    }
     
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeGameSettingsModal);